import React from 'react';
import PropTypes from 'prop-types';

export const PluginGalleryIcon = ({ small = false, ...rest }) => {
  if (small) {
    return (
      <svg
        width="51"
        height="25"
        viewBox="0 0 51 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path
          d="M0.5 1.5C0.5 1.22386 0.723858 1 1 1H14C14.2761 1 14.5 1.22386 14.5 1.5V23.5C14.5 23.7761 14.2761 24 14 24H1C0.723858 24 0.5 23.7761 0.5 23.5V1.5Z"
          fill="#F4F4F4"
          stroke="#AEAEAE"
        />
        <path
          d="M18.5 1.5C18.5 1.22386 18.7239 1 19 1H32C32.2761 1 32.5 1.22386 32.5 1.5V9.5C32.5 9.77614 32.2761 10 32 10H19C18.7239 10 18.5 9.77614 18.5 9.5V1.5Z"
          fill="#F4F4F4"
          stroke="#AEAEAE"
        />
        <path
          d="M18.5 14.5C18.5 14.2239 18.7239 14 19 14H32C32.2761 14 32.5 14.2239 32.5 14.5V22.5C32.5 22.7761 32.2761 23 32 23H19C18.7239 23 18.5 22.7761 18.5 22.5V14.5Z"
          fill="#F4F4F4"
          stroke="#AEAEAE"
        />
        <path
          d="M36.5 1.5C36.5 1.22386 36.7239 1 37 1H50C50.2761 1 50.5 1.22386 50.5 1.5V17.5C50.5 17.7761 50.2761 18 50 18H37C36.7239 18 36.5 17.7761 36.5 17.5V1.5Z"
          fill="#F4F4F4"
          stroke="#AEAEAE"
        />
      </svg>
    );
  }

  return (
    <svg
      width="101"
      height="103"
      viewBox="0 0 101 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect
        x="1.33337"
        y="0.5"
        width="40.7266"
        height="59.4317"
        rx="3.5"
        fill="#F4F4F4"
        stroke="#AEAEAE"
      />
      <rect
        x="48.8154"
        y="0.5"
        width="51.518"
        height="32.0935"
        rx="3.5"
        fill="#F4F4F4"
        stroke="#AEAEAE"
      />
      <rect
        x="1.33337"
        y="68.8453"
        width="40.7266"
        height="32.813"
        rx="3.5"
        fill="#F4F4F4"
        stroke="#AEAEAE"
      />
      <rect
        x="48.8154"
        y="40.7878"
        width="51.518"
        height="60.8705"
        rx="3.5"
        fill="#F4F4F4"
        stroke="#AEAEAE"
      />
    </svg>
  );
};

PluginGalleryIcon.propTypes = {
  small: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/vp-ui/svgs/PluginGalleryIcon.jsx